<template>
  <div>
    <p>{{ label }} {{ details.type }} {{ objectType.toLowerCase() }} <strong>{{details.name}}</strong> (<a :href="link">{{ objectType }}</a>)</p>
  </div>
</template>

<script>
export default {
  name: "Source",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  computed: {
    link() {
      if (this.details.category == "conversation") {
        return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/messaging/${this.details.category}/${this.details.id}/edit`;
      } else {
        return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/sources/${this.details.category}/${this.details.id}`;
      }
    },
    objectType() {
      return this.details.category == "conversation" ? 'Conversation' : 'Data Source';
    }
  }
}
</script>

<style scoped>

</style>